<template>
  <v-container>
    <v-row justify="space-around">
      <v-col>
        <v-row>
          <v-col>
            <v-btn
              color="#4d48f9"
              style="text-transform: none !important; color: white;"
              @click="routeCompanyAdd()"
            >
              YENİ FİRMA EKLE
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              color="#4d48f9"
              style="text-transform: none !important; color: white;"
              v-if="isAdmin"
              @click="openImportModal()"
            >
              IMPORT
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="#4d48f9"
              style="text-transform: none !important; color: white;"
              v-if="isAdmin"
              @click="exportData()"
            >
              EXPORT
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row>
      <v-col cols="12" md="4" sm="4">
        <h4>Aktiflik/Pasiflik</h4>
        <v-select
          v-model="companyPageData.active"
          @change="filterByCompaniesStatus"
          :items="statusFilterItems"
          item-text="name"
          item-value="value"
          data-vv-name="select"
          required
        ></v-select>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        Firmalar
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allCompanies"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.active="{ item }">
          <v-checkbox
            v-model="item.active"
            color="#4d48f9"
            @change="companyStatusChange(item)"
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeCompanyEdit(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="companyPageData.pageNumber"
          color="#4d48f9"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="importModalOpen" max-width="600px">
      <v-card>
        <v-card-title>Import Data</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="9">
              <v-file-input
                v-model="importFile"
                accept=".csv, .xlsx, .xls"
                label="Dosya seçiniz"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="downloadSampleExcel"
                  >
                    Örnek Dosya İndir
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="end" class="mx-2">
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="uploadFile"
                  >
                    Yükle
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="closeImportModal"
                  >
                    İptal
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="importFileResponseDialog.show" max-width="600px">
      <v-card>
        <v-card-title>İmport Detay</v-card-title>
        <v-card-text>
          <p>{{ importFileResponseDialog.message }}</p>
          <v-row justify="space-around">
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    v-if="
                      !importFileResponseDialog.isSuccess &&
                      importFileResponseDialog.logFileUrl
                    "
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="
                      downloadLogFileAsync(importFileResponseDialog.logFileUrl)
                    "
                  >
                    Log Dosyasını İndir
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="end" class="mx-2">
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="closeImportFileResponseDialog"
                  >
                    Kapat
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Companies',
  data: () => ({
    isAdmin: false,
    search: '',
    statusFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Aktif',
        value: true,
      },
      {
        name: 'Pasif',
        value: false,
      },
    ],
    companyPageData: {
      search: '',
      pageNumber: 1,
      pageSize: 10,
      active: null,
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      {
        text: 'Firma Adı',
        value: 'companyName',
        align: 'start',
      },
      {
        text: 'Aktif/Pasif',
        value: 'active',
      },
      {
        text: 'Statü',
        value: 'companyStatus',
        sortable: false,
      },
      {
        text: 'Detay',
        value: 'actions',
        sortable: false,
      },
    ],
    importModalOpen: false,
    importFile: null,
    importFileResponseDialog: {
      show: false,
      isSuccess: true,
      message: '',
      count: 0,
      logFileUrl: '',
    },
  }),
  computed: mapGetters(['allCompanies', 'loading', 'importResponse', 'allCompanyStatusReasonType']),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.companyPageData.pageNumber = Number(page)

    this.getCompanyStatusReasonType().then(() => {
      this.getCompanies(this.companyPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    })
    
    if (
      userRoles.find((x) => x == 'PanelUser') != null &&
      userRoles.find((x) => x == 'PanelUser') != undefined
    ) {
      this.isAdmin = true
    }
  },
  methods: {
    ...mapActions([
      'getCompanies',
      'updateCompanyStatus',
      'importCompanies',
      'exportCompanies',
      'exportCompanyTemplate',
      'downloadCompanyLogFile',
      'getCompanyStatusReasonType'
    ]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.companyPageData.pageSize = val
      this.companyPageData.pageNumber = 1

      this.getCompanies(this.companyPageData).then((response) => {
        this.pagination.pagesLength = response.totalPages
      })
    },
    getItemPerSearch(val) {
      this.companyPageData.pageNumber = 1
      this.companyPageData.search = val
      this.getCompanies(this.companyPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.companyPageData.pageNumber = val
      this.getCompanies(this.companyPageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          page: val,
        },
      })
    },
    filterByCompaniesStatus(value) {
      this.companyPageData.active = value
      this.companyPageData.pageNumber = 1
      this.getCompanies(this.companyPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //CompanyStatus
    companyStatusChange(company) {
      console.log('companyStatus', company)
      this.updateCompanyStatus(company)
        .then((response) => {
          console.log('response', response)
          if (response.processStatus == 'Success') {
            alert('Güncelleme işlemi başarılıdır')
          } else {
            alert('Bir hata oluştu')
          }
        })
        .catch((err) => {
          alert(err)
        })
    },
    //CompanyAdd
    routeCompanyAdd() {
      this.$router.push('company')
    },
    //CompanyEdit
    routeCompanyEdit(item) {
      console.log('item', item)
      this.$router.push(`company/${item.id}`)
    },
    processUrlChange(to) {
      if (to.fullPath.split('=').length >= 2) {
        this.getPageNumber(to.query.page)
      } else if (to.fullPath === '/dashboard/companies') {
        this.getPageNumber(1)
      }
    },
    openImportModal() {
      this.importModalOpen = true
    },
    closeImportModal() {
      this.importModalOpen = false
    },
    closeImportFileResponseDialog() {
      this.importFileResponseDialog.show = false
    },
    async downloadLogFileAsync(url) {
      this.downloadCompanyLogFile(url)
    },
    async uploadFile() {
      if (!this.importFile) {
        this.showSnackbar('Please select a file to upload.', 'error')
        return
      }
      await this.importCompanies(this.importFile)
      this.importFile = null
    },
    async exportData() {
      let exportQueryObject = {
        isActive: this.companyPageData.active,
        search: this.companyPageData.search,
      }
      try {
        await this.exportCompanies(exportQueryObject)
      } catch (error) {
        console.error('Export error:', error)
      }
    },
    async downloadSampleExcel() {
      //https://frink.mncdn.com/template/company-excel-template.xlsx
      try {
        await this.exportCompanyTemplate()
      } catch (error) {
        console.error('Export error:', error)
      }
    },
  },
  watch: {
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 2) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
    importResponse(newVal) {
      console.log('New', newVal)
      if (newVal) {
        this.closeImportModal()
        this.importFileResponseDialog.show = true
        if (newVal.success) {
          this.importFileResponseDialog.isSuccess = true
          this.importFileResponseDialog.message = 'Dosya başarıyla yüklenmiştir'
        } else {
          this.importFileResponseDialog.isSuccess = false
          this.importFileResponseDialog.message = newVal.message
          this.importFileResponseDialog.count = newVal.count
          this.importFileResponseDialog.logFileUrl = newVal.logFileUrl
        }
      }
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
</style>
